import * as types from './auth-actions';
import {LOCATION_CHANGE} from 'connected-react-router';

const initState = {
    authenticating: false,
    isAuthenticated: false,
    user: null,
    csrfToken: null,
    updating: false,
    updatingError: null,
    passwordChanging: false,
    previousPath: '/',
    currentPath: '/'
};

export default function AuthReducer (state = initState, action) {

    switch (action.type)
    {
        // Auth Init

        case types.AUTH_INIT:
            return {...state, authenticating: true};

        case types.AUTH_INIT_SUCCESS:
            let user = action.payload || null;
            return {...state, isAuthenticated: (user !== null), user: user, authenticating: false };

        case types.AUTH_INIT_ERROR:
            return {...state, authenticating: false, isAuthenticated: false, user: null};

        // Sign In

        case types.AUTH_SIGN_IN:
            return {...state, authenticating: true, isAuthenticated: false, user: null };

        case types.AUTH_SIGN_IN_SUCCESS:
            return {...state, authenticating: false, isAuthenticated: true, user: action.payload };

        case types.AUTH_SIGN_IN_ERROR:
            return {...state, authenticating: false, isAuthenticated: false };

        // Sign Out

        case types.AUTH_SIGN_OUT:
            return {...state, isAuthenticated: false, user: null };

        case types.AUTH_SIGN_OUT_SUCCESS:
            return state;

        case types.AUTH_SIGN_OUT_ERROR:
            return state;

        // Expired

        case types.AUTH_EXPIRED:
            return {...state, authenticating: false, isAuthenticated: false, user: null };

        case LOCATION_CHANGE:
            return {...state, previousPath: state.currentPath, currentPath: action.payload.location.pathname };

        default:
            return state;
    }

}

